import
{
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import * as mapboxgl from 'mapbox-gl';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-map',
  standalone: true,
  imports: [CommonModule],
  template: `<div id="map" class="match-parent"></div>`,
  styles: [
    `
      .match-parent {
        width: 100%;
        height: 500px;
      }
    `,
  ],
})
export class MapComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() lngLat: mapboxgl.LngLatLike = [-88.036431, 15.497566];
  @Input() zoom = 15.5;
  @Input() markerDraggable = false;
  @Input() geoLocate = false;
  @Output() dragEnd = new EventEmitter<number[]>();

  map: mapboxgl.Map | null = null;
  marker: mapboxgl.Marker | null = null;

  ngOnInit(): void
  {

  }

  ngAfterViewInit()
  {
    setTimeout(() =>
    {
      this.initializeMap();
    }, 0);
  }

  ngOnChanges(changes: SimpleChanges)
  {
    if (this.map)
    {
      if (changes.lngLat && !changes.lngLat.isFirstChange())
      {
        this.map.setCenter(this.lngLat);
      }

      if (changes.zoom && !changes.zoom.isFirstChange())
      {
        this.map.setZoom(this.zoom);
      }

      // Actualiza el marcador si es arrastrable y si su posición cambió
      if (this.markerDraggable && this.marker && changes.lngLat && !changes.lngLat.isFirstChange())
      {
        this.marker.setLngLat(this.lngLat);
      }
    }
  }

  initializeMap(): void
  {
    document.getElementById('map').innerHTML = '';

    this.map = new mapboxgl.Map({
      accessToken: environment.MAPBOX_ACCESS_TOKEN,
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v12',
      zoom: this.zoom,
      center: this.lngLat,
    });

    this.map.on('load', () =>
    {
      this.map.resize();
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.setCenter(this.lngLat);

      if (this.geoLocate)
      {
        this.map.addControl(new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: false,
          showUserHeading: true,
        }));
      }

      if (this.markerDraggable)
      {
        this.marker = new mapboxgl.Marker({ draggable: true })
          .setLngLat(this.lngLat)
          .addTo(this.map);

        this.marker.on('dragend', () =>
        {
          const lngLat = this.marker.getLngLat();
          this.dragEnd.emit([lngLat.lng, lngLat.lat]);
        });
      }
    });
  }

  ngOnDestroy()
  {
    if (this.map)
    {
      this.map.remove();
      this.map = null;
    }

    if (this.marker)
    {
      this.marker.remove();
      this.marker = null;
    }
  }
}
